export interface KnowledgeEntity {
  id: string;
  canonicalKey: string;
  name: string;
  type: 'COUNTRY' | 'CURRENCY' | 'FINANCIAL_CONCEPT' | 'CALCULATOR' | 'TOOL' | 'PROVIDER' | 'TAX_RULESET';
  description: string;
  aliases: string[];
  trustTier: 'TIER_A_OFFICIAL' | 'TIER_B_PRIMARY_PROVIDER' | 'TIER_C_VERIFIED_SECONDARY' | 'TIER_D_EDITORIAL';
  lastVerifiedAt: string;
}

export interface KnowledgeRelation {
  sourceId: string;
  targetId: string;
  relationType: 'USES_CURRENCY' | 'HAS_JURISDICTION' | 'HAS_RULESET' | 'EXPLAINED_BY' | 'SUPPORTED_BY';
}

export const INITIAL_KNOWLEDGE_ENTITIES: KnowledgeEntity[] = [
  {
    id: 'ent-usd',
    canonicalKey: 'CURRENCY_USD',
    name: 'US Dollar (USD)',
    type: 'CURRENCY',
    description: 'Official currency of the United States and global reserve currency.',
    aliases: ['dollar', 'dollars', 'us dollar', '$'],
    trustTier: 'TIER_A_OFFICIAL',
    lastVerifiedAt: '2026-08-01',
  },
  {
    id: 'ent-eur',
    canonicalKey: 'CURRENCY_EUR',
    name: 'Euro (EUR)',
    type: 'CURRENCY',
    description: 'Official currency of the Eurozone member states.',
    aliases: ['euro', 'euros', '€'],
    trustTier: 'TIER_A_OFFICIAL',
    lastVerifiedAt: '2026-08-01',
  },
  {
    id: 'ent-apr',
    canonicalKey: 'CONCEPT_APR',
    name: 'Annual Percentage Rate (APR)',
    type: 'FINANCIAL_CONCEPT',
    description: 'The yearly interest generated by a sum that is charged to borrowers or paid to investors.',
    aliases: ['apr', 'annual percentage rate', 'interest rate'],
    trustTier: 'TIER_A_OFFICIAL',
    lastVerifiedAt: '2026-07-15',
  },
  {
    id: 'ent-cal-salary',
    canonicalKey: 'TOOL_SALARY_ENGINE',
    name: 'YamooPay Global Salary & Tax Engine',
    type: 'CALCULATOR',
    description: 'Deterministic engine calculating net take-home pay, federal, state and social taxes.',
    aliases: ['salary calculator', 'tax engine', 'paycheck calculator'],
    trustTier: 'TIER_A_OFFICIAL',
    lastVerifiedAt: '2026-08-20',
  },
  {
    id: 'ent-cal-mortgage',
    canonicalKey: 'TOOL_MORTGAGE_ENGINE',
    name: 'YamooPay Mortgage & Loan Engine',
    type: 'CALCULATOR',
    description: 'Deterministic mortgage amortization and affordability calculations.',
    aliases: ['mortgage calculator', 'loan calculator', 'affordability calculator'],
    trustTier: 'TIER_A_OFFICIAL',
    lastVerifiedAt: '2026-08-20',
  }
];

export function queryKnowledgeGraph(searchTerm: string): KnowledgeEntity[] {
  const term = searchTerm.toLowerCase();
  return INITIAL_KNOWLEDGE_ENTITIES.filter(
    (e) =>
      e.name.toLowerCase().includes(term) ||
      e.description.toLowerCase().includes(term) ||
      e.aliases.some((a) => a.includes(term))
  );
}
